<template>
  <p :class="['text-body', textAlignClass, `text-${color}`]">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'SAISectionSubTitle',
  props: {
    text: {
      type: String
    },
    color: {
      type: String,
      default: 'grey-5'
    },
    textAlign: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    textAlignClass() {
      return this.textAlign ? `text-${this.textAlign}` : '';
    }
  }
};
</script>
